import { Component, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConfigService, UserService, VersionService } from '@core/services';
import { map } from 'rxjs';

@Component({
  selector: 'app-support-links-panel',
  standalone: false,
  templateUrl: './support-links-panel.component.html',
  styleUrl: './support-links-panel.component.scss',
})
export class SupportLinksPanelComponent {
  public isZendeskAgent = signal<boolean>(false);
  version = toSignal(
    this.versionService.getVersion().pipe(
      map((versions) => {
        return versions?.length ? versions[0] : null;
      }),
    ),
  );
  constructor(
    private userService: UserService,
    private versionService: VersionService,
    private readonly configService: ConfigService,
  ) {
    this.isZendeskAgent.set(this.userService.isUserZendeskAgent ? this.userService.isUserZendeskAgent : false);
  }

  get zendeskLink() {
    return this.configService.zendeskUrl + (this.isZendeskAgent() ? '/agent/' : '/hc/en-us/requests/organization');
  }

  get mailToSupport() {
    return `mailto:${this.configService.feedbackEmail}`;
  }
}
